var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('img',{staticClass:"logo",attrs:{"alt":"Hoikuen logo","src":"/assets/LOGO.jpg"}}),_c('p',[_vm._v("合同会社アミーのページです。")]),_c('p',[_vm._v("2019年11月に合同会社を設立しました。")]),_c('p',[_vm._v("ただいま事業開始にむけて準備中です。")])])}
var staticRenderFns = []

export { render, staticRenderFns }